export const TEST_EVENT_TYPE = 'test';

// NOTE: this is taken from our Svix fork
// https://github.com/Finch-API/svix-webhooks/blob/92acd1f7432351899f225b7697f3dd400fc2132c/kubernetes/values.yaml#L75
export const SVIX_RETRY_SCHEDULE = [5, 300, 1800, 7200];
export const MAX_ATTEMPTS = 1 + SVIX_RETRY_SCHEDULE.length;
